import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup } from "firebase/auth";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase configuration (replace with your actual config)
const firebaseConfig = {
    apiKey: "AIzaSyAK2H5XyfgYkxY8Rd9CacNEmaNrV_jDEw0",
    authDomain: "khizar-e9dc8.firebaseapp.com",
    databaseURL: "https://khizar-e9dc8.firebaseio.com",
    projectId: "khizar-e9dc8",
    storageBucket: "khizar-e9dc8.firebasestorage.app",
    messagingSenderId: "947245714081",
    appId: "1:947245714081:web:988b9ae8934f826086fee0"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

// Configure Apple OAuth Provider
// NOTE: Apple credentials must be configured in Firebase Console:
// 1. Go to Firebase Console > Authentication > Sign-in method
// 2. Enable Apple Sign-In
// 3. Configure with your Apple Developer credentials:
//    - Apple Team ID (e.g., ABC123DEF4)
//    - Apple Service ID (e.g., com.yourcompany.appname)
//    - Apple Key ID (e.g., XYZ789KEY)
//    - Apple Private Key (.p8 file)

const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

const messaging = getMessaging();

export { auth, googleProvider, appleProvider, messaging, signInWithPopup, getToken, onMessage };
